import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import AdminMenu from '../AdminMenu/AdminMenu';

const ModerationAdmin = ({ hash, title, type }) => {
    const [showAdminMenu, setShowAdminMenu] = useState(false);
    const [cmsLink, setCmsLink] = useState('');
    const [adminMenu, setAdminMenu] = useState([]);

    const toggleAdminMenu = useCallback(async () => {
        if (!showAdminMenu) {
            const res = await axios.get(
                `/api/content-management/admin-menu/${type}/${hash}`
            );
            setAdminMenu(res.data?.actions);
            setCmsLink(res.data?.cmsLink);
            setShowAdminMenu(!showAdminMenu);
        }
    }, [showAdminMenu, type, hash]);

    const closeAdminMenu = useCallback(
        () => setShowAdminMenu(false),
        [setShowAdminMenu]
    );

    return (
        <div
            className="component-ModerationAdmin"
            onClick={toggleAdminMenu}
            onKeyPress={toggleAdminMenu}
            role="button"
            tabIndex={0}
        >
            <style jsx>
                {`
                    .component-ModerationAdmin {
                        display: flex;
                        align-items: center;
                        width: 100%;
                    }
                    .component-ModerationAdmin:focus {
                        outline: none;
                    }
                    .component-ModerationAdmin .moderationAdmin-label {
                        padding-left: 6px;
                        font-size: 14px;
                        line-height: 34px;
                        color: #353535;
                        padding-top: 2px;
                    }
                    @media (max-width: 905px) {
                        .Admin-menu .allContent {
                            height: 300px !important;
                        }
                    }
                `}
            </style>
            <span className="moderationAdmin-label">Admin tools</span>
            {showAdminMenu && type !== 'jobbing' && (
                <AdminMenu
                    hash={hash}
                    type={type}
                    contentTitle={title}
                    adminMenu={adminMenu}
                    cmsLink={cmsLink}
                    openAdminMenu={showAdminMenu}
                    closeAdminMenu={closeAdminMenu}
                    toggleAdminMenu={toggleAdminMenu}
                    showMenuIcon={false}
                />
            )}
        </div>
    );
};

ModerationAdmin.propTypes = {
    hash: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};
ModerationAdmin.defaultProps = {};

ModerationAdmin.displayName = 'ModerationAdmin';

export default ModerationAdmin;
